import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const TransferOfGoodsDetailMain = () => {
  const { watch } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <div className={"panel-body tabs-menu-body main-content-body-right"}>
        <Row>
          <Col sm={6}>
            <NFTextInput title={t("Document#")} fieldName={"documentNumber"} disabled={true} />
          </Col>
          <Col sm={6}>
            <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required={true} />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupWarehouse fieldName={"warehouseExpensingId"} title={t("WarehouseExpensing")} required companyId={watch("companyId")} />
          </Col>
          <Col sm={6}>
            <NFLookupWarehouse fieldName={"warehouseReceivingId"} title={t("WarehouseReceiving")} required companyId={watch("companyId")} />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <NFLookupDivision fieldName={"divisionId"} companyId={watch("companyId")} title={t("Division")} required />
          </Col>
          <Col sm={6}>
            <NFLookupCompany fieldName={"companyId"} title={t("Company")} required />
          </Col>
        </Row>
      </div>
    </>
  );
};
